export default "__VITE_ASSET__DiLbnCzA__"